import MultiStepForm from "./components/MultiStepForm.jsx"

function App() {
  return (
    <div className="App">
      <MultiStepForm />
    </div>
  );
}

export default App;
